import "./App.css";
import { ToastContainer } from "react-toastify";
import RoutesManager from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { Provider } from "react-redux";
import { msalConfig } from "./config";
import { store } from "./redux/store";
import Loader from "./components/loader";

declare global {
  interface Window {
    msalInstance: PublicClientApplication;
  }
}

function App() {
  const msalInstance = new PublicClientApplication(msalConfig);

  window.msalInstance = msalInstance;

  return (
    <div className="App">
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <Loader />
          <RoutesManager />
          <ToastContainer
            closeButton={false}
            autoClose={5000}
            newestOnTop
            pauseOnHover
            position="top-center"
          />
        </MsalProvider>
      </Provider>
    </div>
  );
}

export default App;
